<template>
    <v-btn color="#ddd" fab tile outlined fixed transition="slide-x-transition" class="scroll-top" @click="$vuetify.goTo(target, options)"></v-btn>
</template>

<script>
export default {
    data(){
        return {
            type: 'number',
            number: 0,
            duration: 500,
            offset: 0,
            easing: 'easeInOutCubic',

            show: false,
        };
    },
    mounted(){
    },
    methods: {
    },
    computed: {
        target : function() {
            const value = this[this.type]
            if (!isNaN(value)) return Number(value)
            else return value
        },
        options : function() {
            return {
                duration: this.duration,
                offset: this.offset,
                easing: this.easing,
            }
        },
    },
}
</script>

